<template>
  <div>
    <div class="content mb10">
      <div class="bottom-line">
        <div class="common-title">明确项目核心要求，做职位更精准。【非必填信息】</div>
        <el-row
          :gutter="20"
          style="border-bottom:1px solid #e2e2e2;padding:0 0 20px 0;margin:0"
          type="flex"
          align="center"
        >
          <div style="padding-left:0;font-size:16px;margin-right:10px">核心要求</div>
          <el-col :span="16" style="padding-left:0">
            <el-input v-model="copyProject.核心要求" type="textarea" placeholder="请填写客户提出的必须满足的核心要求"></el-input>
          </el-col>
        </el-row>
        <h3 class="common-title mb10">以下为客户相关信息，会和客户公司联动【非必填信息】</h3>
        <div class="display-flex mb10">
          <div class="tip-text-left">
            <p style="padding: 8px 0;font-size: 16px;" class="mb10">客户最关注的问题</p>
            <div
              v-for="(question, index) in company.关注问题"
              :key="`question${index}`"
              class="display-flex align-center mb10"
            >
              <span class="mr5">Q:</span>
              <p>{{ question }}</p>
            </div>

            <div
              v-for="(question, index) in copyProject.关注问题"
              :key="`projectQuestion${index}`"
              class="display-flex align-center mb10"
            >
              <span class="mr5">Q:</span>
              <el-input v-model="copyProject.关注问题[index]" placeholder="输入的问题会自动进入人选会谈" size="mini"></el-input>
            </div>
            <a @click="addQuestion">
              <i class="el-icon-circle-plus" />增加一条问题
            </a>
          </div>
          <div class="tip-text-right">
            <p class="tip-text">1、客户公司的问题及应对会自动联动到此处，也可自行修改和增加该职位特有问题；</p>
            <p class="tip-text">2、客户最关注的的问题会成为该项目人选会谈的问题；</p>
          </div>
        </div>
        <div class="bottom-line"></div>
        <div class="mb10">
          <p style="padding: 8px 0;font-size: 16px;" class="mb10">面试流程及面试安排</p>
          <div class="display-flex">
            <span class="keep-all">面试流程：</span>
            <el-input
              v-model="copyProject.面试流程"
              type="textarea"
              :rows="3"
              :placeholder="
                `例如：业务线电话直接约面试--业务领导见面（可能3个业务线的，也有可能直接部门B角）-A角见面-见投行委领导-后期可能会有测试（要考英语，财管计算等）`
              "
            ></el-input>
          </div>
        </div>

        <!-- <div class="tip-text-left mb10">
          <a @click="addInterviewer">
            关键面试决策人
            <i class="el-icon-circle-plus mb10" />
          </a>
          <div class="display-flex flex-wrap">
            <div
              v-for="(item, index) in interviewer"
              :key="`interview${index}`"
              class="radish-card mr10 mb5"
            >
              <span class="close" @click="removeInterviewer(item)">X</span>
              <div style="width:40%;margin-right:20px" >
                <span class="name">
                  <span class="drawer-link" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
                </span>
                <span class="name" style="color:#000">
                  <span>{{ item.目前职位 }}</span>
                </span>
              </div>
              <div>
                <p class="tel">{{ item.手机 }}</p>
                <p>{{ item.座机 }}</p>
                <p>{{ item.邮箱 }}</p>
              </div>
            </div>
          </div>
        </div>-->
        <div class="mb10">
          <p>
            <el-popover
              v-if="company._id"
              v-model="companyInterviewerVisible"
              placement="right"
              width="800"
              trigger="click"
            >
              <div
                class="propject_detail_info_table col-1"
                style="max-height:70vh;font-size:14px;padding:10px"
              >
                <p style="text-align:center;margin-bottom:20px" class="flex-row">
                  <el-input
                    v-model="temporaryInterviewerKeyword"
                    size="mini"
                    placeholder="输入姓名进行搜索"
                  ></el-input>
                  <el-button
                    @click="getTemporaryInterviewers(temporaryInterviewerKeyword)"
                    size="mini"
                    type="primary"
                  >搜索</el-button>
                </p>
                <p class="mb10" style="color:#409EFF">点击选择一位关键面试决策人(可多选)</p>
                <div v-if="interviewerLoading" class="loading-mask">
                  <i class="el-icon-loading"></i>
                </div>
                <div v-else>
                  <div class="flex-row project_table_thead item-center">
                    <span
                      class="propject_detail_info_table_cell col-2 propject_detail_info_label"
                    >姓名</span>
                    <span
                      class="propject_detail_info_table_cell col-2 propject_detail_info_label"
                    >公司</span>
                    <span
                      class="propject_detail_info_table_cell col-2 propject_detail_info_label"
                    >部门</span>
                    <span
                      class="propject_detail_info_table_cell col-2 propject_detail_info_label"
                    >目前职位</span>
                    <span
                      class="propject_detail_info_table_cell col-2 propject_detail_info_label"
                    >职级</span>
                    <span
                      class="propject_detail_info_table_cell col-2 propject_detail_info_label"
                    >职能模块</span>
                  </div>
                  <div
                    v-for="(value, i) in temporaryInterviewer"
                    :key="`companyHr${i}`"
                    :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                    @click="chooseInterviewer(value)"
                  >
                    <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['公司'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['部门'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">
                      <el-tag
                        size="mini"
                        type="primary"
                        v-for="item in value['职能模块']"
                        :key="item"
                      >{{item}}</el-tag>
                    </span>
                  </div>
                </div>
              </div>
              <a slot="reference">
                关键面试决策人
                <i class="el-icon-circle-plus mb10" />
              </a>
            </el-popover>
          </p>
          <div class="display-flex flex-wrap">
            <div
              v-for="(item, index) in interviewer"
              :key="`interviewer${index}`"
              class="radish-card mr10 mb5"
            >
              <span class="close" @click="removeInterviewer(item)">X</span>
              <div style="width:40%;margin-right:20px">
                <span class="name">
                  <!-- {{item.姓名}} -->
                  <span class="drawer-link" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
                </span>
                <span class="name" style="color:#000">
                  <span>{{ item.目前职位 }}</span>
                </span>
              </div>
              <div>
                <p class="tel">{{ item.手机 }}</p>
                <p>{{ item.座机 }}</p>
                <p>{{ item.邮箱 }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb10">
          <p>
            <el-popover
              v-if="company._id"
              v-model="companyHRVisible"
              placement="right"
              width="800"
              trigger="click"
            >
              <div class="propject_detail_info_table col-1" style="font-size:14px;padding:10px">
                <p class="mb10" style="color:#409EFF">点击选择一位HR(可多选)</p>
                <div class="flex-row project_table_thead item-center">
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                  <span
                    class="propject_detail_info_table_cell col-2 propject_detail_info_label"
                  >目前职位</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">手机</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">座机</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">邮箱</span>
                </div>
                <div
                  v-for="(value, i) in company['对接hr']"
                  :key="`companyHr${i}`"
                  :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                  @click="addHR2Project(value)"
                >
                  <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
                </div>
                <el-button @click="insertCompanyHr" style="width:100%;" type="primary" plain>新增一位HR</el-button>
              </div>
              <a slot="reference">
                对接hr
                <i class="el-icon-circle-plus mb10" />
              </a>
            </el-popover>
          </p>
          <div class="display-flex flex-wrap">
            <div
              v-for="(item, index) in projectHRs"
              :key="`projectHr${index}`"
              class="radish-card mr10 mb5"
            >
              <span class="close" @click="removeProjectHr(item)">X</span>
              <div style="width:40%;margin-right:20px">
                <span class="name">
                  <!-- {{item.姓名}} -->
                  <span class="drawer-link" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
                </span>
                <span class="name" style="color:#000">
                  <span>{{ item.目前职位 }}</span>
                </span>
              </div>
              <div>
                <p class="tel">{{ item.手机 }}</p>
                <p>{{ item.座机 }}</p>
                <p>{{ item.邮箱 }}</p>
              </div>
            </div>
            <div
              v-for="(item, index) in temporaryHr"
              :key="`temporaryHr${index}`"
              class="radish-card mr10 mb5"
            >
              <span class="close" @click="removeTemporaryHr(item)">X</span>
              <div style="width:40%;margin-right:20px">
                <span class="name">
                  <!-- {{item.姓名}} -->
                  <span class="drawer-link" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
                </span>
                <span class="name" style="color:#000">
                  <span>{{ item.目前职位 }}</span>
                </span>
              </div>
              <div>
                <p class="tel">{{ item.手机 }}</p>
                <p>{{ item.座机 }}</p>
                <p>{{ item.邮箱 }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="mb10">
          <!-- <a @click="toAddAddress" class="mb10" style="display:block">
            面试地址
            <i class="el-icon-circle-plus mb10" />
          </a>-->
          <el-popover
            v-if="company._id"
            v-model="companyAddressVisible"
            placement="right"
            width="800"
            trigger="click"
          >
            <div class="propject_detail_info_table col-1" style="font-size:14px">
              <!-- <el-button
                icon="el-icon-close"
                style="position:absolute;top:-14px;right:-14px"
                circle
                type="danger"
                size="mini"
                @click="companyAddressVisible=false"
              ></el-button>-->
              <p class="mb10" style="color:#409EFF">点击选择一个面试地址(可多选)</p>
              <div
                class="flex-row justify-between project_table_thead item-center"
                style="min-height:40px"
              >
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
              </div>
              <div
                style="min-height:40px"
                v-for="(value, i) in company['面试地址']"
                :key="`address${i}`"
                :class="`flex-row justify-between propject_detail_info_table_row_link item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
                @click="addAddress2Project(value)"
              >
                <span class="propject_detail_info_table_cell col-1">{{ value['地址'] }}</span>
                <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
              </div>
              <el-button @click="toAddAddress" style="width:100%;" type="primary" plain>新增面试地址</el-button>
            </div>
            <a slot="reference" @click="companyAddressVisible=!companyAddressVisible">
              面试地址
              <i class="el-icon-circle-plus mb10" />
            </a>
          </el-popover>
          <div
            class="propject_detail_info_table col-1"
            style="font-size:14px"
            v-if="copyProject['面试地址']&&copyProject['面试地址'].length>0"
          >
            <div
              class="flex-row justify-between project_table_thead item-center"
              style="min-height:40px"
            >
              <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
              <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
            </div>
            <div
              style="min-height:40px"
              v-for="(value, i) in copyProject['面试地址']"
              :key="`address${i}`"
              :class="`flex-row justify-between item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
            >
              <a class="col-0" @click="removeCompanyAddress(value._id)">
                <i class="el-icon-remove" />
              </a>
              <span class="propject_detail_info_table_cell col-1">{{ value['地址'] }}</span>
              <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h3 class="common-title mb10">客户特殊要求</h3>
        <div>
          <el-button type="primary" size="mini" @click="showDialog">填写客户特殊要求</el-button>
        </div>
      </div>
    </div>

    <div class="handle-buttons">
      <el-button type="primary" size="mini" @click="confirm">下一步</el-button>
    </div>

    <!-- component -->
    <specialRequest ref="specialRequest" :project="copyProject"></specialRequest>
    <!-- 搜索人选弹窗 -->
    <search-radish-dialog
      ref="searchRadishDialog"
      :could-insert="true"
      choose-btn-text="选择"
      @choose="chooseRadish"
    ></search-radish-dialog>
    <!-- 新增面试地址 -->
    <addCompanyAddress ref="addCompanyAddress" @addAddress="addAddress"></addCompanyAddress>

    <!-- 选择同步到公司的数据 -->
    <choossAddToCompany
      ref="choossAddToCompany"
      :project="copyProject"
      :company="company"
      @cancel="next"
      @projectAddCompanyData="getProject"
    ></choossAddToCompany>
  </div>
</template>

<script>
import specialRequest from './specialRequest'
import choossAddToCompany from './chooseAddToCompany'
import searchRadishDialog from '../../../../company/src/component/serchRadishDialog.vue'
import addCompanyAddress from '../../../../company/src/dialog/addCompanyAddress'

export default {
  components: { specialRequest, searchRadishDialog, addCompanyAddress, choossAddToCompany },
  props: {
    project: { type: Object, default: () => ({}) },
    activeCarousel: { type: Object, default: () => ({}) },
  },
  data () {
    return {
      copyProject: {},
      company: {},
      interviewer: [],
      temporaryInterviewer: [],
      temporaryInterviewerKeyword: "",
      temporaryHr: [],
      projectHrids: [],
      projectHRs: [],
      dialogVisible: false,
      companyHRVisible: false,
      companyInterviewerVisible: false,
      companyAddressVisible: false,
      interviewerLoading: false
    }
  },
  watch: {
    project: {
      handler (newValue, oldValue) {
        this.copyProject = newValue
        if (!this.copyProject.关注问题) this.$set(this.copyProject, '关注问题', [''])
        if (!this.copyProject.对接hr) this.$set(this.copyProject, '对接hr', [])
        if (!this.copyProject.项目对接hr) this.$set(this.copyProject, '项目对接hr', [])
        if (!this.copyProject.核心要求) this.$set(this.copyProject, '核心要求', '')
        if (!this.copyProject.面试地址) this.$set(this.copyProject, '面试地址', [])
        this.getInterviewer()
        this.getTemporaryHrs()
        if (!oldValue) {
          this.getTemporaryInterviewers()
        }
        this.projectHrids = this.copyProject.对接hr
      },
      immediate: true,
      deep: true,
    },
    async projectHrids (newValue, oldValue) {
      const res = await app.service('company').getCompanyHrsByIds(newValue || [])
      this.projectHRs = res.status === 'success' ? res.data : []
    },
    activeCarousel: {
      handler (newValue, oldValue) {
        if (newValue.name === 'pageThree') {
          this.getCompany()
          this.getInterviewer()
        }
      },
      immediate: true,
    },
    companyInterviewerVisible (val) {
      if (val) {
        this.getTemporaryInterviewers()
      }
    }
  },
  async mounted () { },
  methods: {
    getProject () {
      this.getCompany()
      this.$emit('getProject')
      this.next()
    },
    next () {
      this.$emit('next')
    },
    showDialog () {
      this.dialogVisible = true
      this.$refs.specialRequest.open()
    },
    addQuestion () {
      this.copyProject.关注问题.push('')
    },
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    async insertCompanyHr () {
      let defaultSearchRadishes = []
      const res = await app.service('company').defaultSearchHrs(this.company.简称)
      if (res.status === 'success') defaultSearchRadishes = res.data
      else this.$message.error(res.msg)
      this.$refs.searchRadishDialog.open({ 公司: this.company.简称 }, defaultSearchRadishes)
      this.insertType = 'hr'
      this.$el.click()
    },
    addInterviewer () {
      this.insertType = 'interviewer'
      this.$refs.searchRadishDialog.open()
    },
    async getCompany () {
      if (!this.copyProject['客户公司']) return
      try {
        const res = await app.service('company').getCompany(this.copyProject['客户公司'])
        this.company = res.result
        this.copyProject.其他 = res.result.特殊要求
        this.company.对接hr = await this.hr2radish(this.company.对接hr)
        this.company.领导 = await this.leaders2radish(this.company.领导)
      } catch (e) {
        console.error(e)
      }
    },
    async hr2radish (hrs) {
      const res = await app.service('company').getCompanyHr(hrs || [])
      if (res.status === 'success') return res.data
      else {
        this.$message(res.msg)
        return []
      }
    },
    async leaders2radish (leaders) {
      const res = await app.service('company').getLeaders(leaders)
      if (res.status === 'success') return res.data
      else {
        this.$message(res.msg)
        return []
      }
    },
    chooseRadish (radish) {
      if (this.insertType === 'interviewer') this.chooseInterviewer(radish)
      else if (this.insertType === 'hr') this.chooseHr(radish)
    },
    chooseHr (radish) {
      if (!this.copyProject['项目对接hr']) this.$set(this.copyProject, '项目对接hr', [])
      if (!this.projectHrids.includes(radish._id) && !this.copyProject['项目对接hr'].includes(radish._id))
        this.copyProject['项目对接hr'].push(radish._id)
      this.temporaryHr.push(radish)
    },
    chooseInterviewer (radish) {
      if (!this.copyProject['关键面试人']) this.$set(this.copyProject, '关键面试人', [])
      if (!this.copyProject['关键面试人'].includes(radish._id)) this.copyProject['关键面试人'].push(radish._id)
      this.$message({ type: 'success', message: `添加成功` })
      this.getInterviewer()
    },
    async getInterviewer () {
      const ids = this.copyProject['关键面试人']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.interviewer = res.data
      } else this.interviewer = []
    },
    async getTemporaryHrs () {
      const ids = this.copyProject['项目对接hr']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.temporaryHr = res.data
      } else this.temporaryHr = []
    },
    async getTemporaryInterviewers (name) {
      this.interviewerLoading = true
      const postData = {
        type: "人选",
        keywords: "",
        and: false,
        query: {},
        $page: 1,
        $limit: 300,
        $sort: {
          公司排名: 1,
          公司: -1,
          部门: -1,
          职级: 1,
          createdAt: -1,
        },
        fields: ["简介", "沟通日志", "旧系统沟通备注", "职能模块", "细分职能", "个性标签", "擅长方向", "行业", "部门", "组别", "目前职位", "姓名^5", "英文名", "地域", "平台", "职级", "业绩", "性别", "婚育", "籍贯", "公司^5", "曾任职公司", "管理职级", "专业职级", "学历", "学历标签", "语言标签", "职业资格", "香港牌照", "投资风格", "*院校"]
      }
      if (name) {
        postData.query = { 公司: this.copyProject['客户公司'], 姓名: name }
        const { data: { data } } = await app.service('radish').listEs(postData)
        this.temporaryInterviewer = data
        this.temporaryInterviewerKeyword = ""
        this.interviewerLoading = false
      } else {
        postData.query = { 职级: ["1", "2"], 公司: this.copyProject['客户公司'] }
        const res1 = await app.service('radish').listEs(postData)
        if (this.copyProject['职能模块']) {
          postData.query = { 公司: this.copyProject['客户公司'], 职能模块: this.copyProject['职能模块'] ? [this.copyProject['职能模块']] : [] }
          const res2 = await app.service('radish').listEs(postData)
          const data = res1.data.data.concat(res2.data.data)
          this.temporaryInterviewer = data
          this.temporaryInterviewerKeyword = ""
          this.interviewerLoading = false
        } else {
          const data = res1.data.data
          this.temporaryInterviewer = data
          this.temporaryInterviewerKeyword = ""
          this.interviewerLoading = false
        }
      }

    },
    addAddress2Project (item) {
      if (this.copyProject['面试地址'].every(val => val._id !== item._id)) {
        this.copyProject['面试地址'].push(item)
      }
    },
    async addHR2Project (value) {
      const hrid = value._id
      if (this.projectHrids && this.projectHrids.length > 0) {
        const exist = this.projectHrids.find(_hrid => _hrid === hrid)
        if (exist) return
      }
      try {
        await app.service('project').addProjectHR({ id: this.copyProject._id, hrid })
        this.projectHrids.push(hrid)
        this.$message({ type: 'success', message: `添加成功` })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async removeProjectHr (value) {
      const hrid = value._id
      try {
        await app.service('project').removeProjectHR({ id: this.copyProject._id, hrid })
        const index = this.projectHrids.findIndex(_hrid => _hrid === hrid)
        if (index === -1) return
        this.projectHrids.splice(index, 1)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    removeTemporaryHr (hr) {
      const index = this.temporaryHr.findIndex(_hrid => _hrid === hr._id)
      const idIndex = this.copyProject['项目对接hr'].findIndex(_hrid => _hrid === radish._id)
      if (index === -1) return
      this.copyProject['项目对接hr'].splice(idIndex, 1)
      this.temporaryHr.splice(index, 1)
    },
    removeInterviewer (radish) {
      const index = this.interviewer.findIndex(_hrid => _hrid._id === radish._id)
      const idIndex = this.copyProject['关键面试人'].findIndex(_hrid => _hrid === radish._id)
      if (index === -1) return
      this.copyProject['关键面试人'].splice(idIndex, 1)
      this.interviewer.splice(index, 1)
    },
    toAddAddress () {
      this.$refs.addCompanyAddress.open()
    },
    async addAddress (obj) {
      obj.cid = this.company._id
      try {
        const res = await app.service('company').addCompanyAddress(obj)
        if (res.status === 'success') {
          this.company['面试地址'] = res.data
          this.copyProject['面试地址'].push(res.data[res.data.length - 1])
        }
        this.$message({ type: 'success', message: `添加成功` })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async removeCompanyAddress (_id) {
      this.copyProject['面试地址'] = this.copyProject['面试地址'].filter(ele => ele._id !== _id)
    },
    confirm () {
      this.$emit('modifyProject')
      this.$refs.choossAddToCompany.open({ questions: this.copyProject.关注问题, hrs: this.temporaryHr })
    },
  },
}
</script>
<style scoped src="../../../statistics/css/addProject.css"></style>
